import React from 'react'
import { useSelector } from 'react-redux'

import { getCurrentCandidate } from '@/core/selectors/candidate'

import styles from './styles'

const AdminPanel = () => {
  const { id: candidateId } = useSelector(getCurrentCandidate)

  return (
    <a href={`/tara/portfolio/${candidateId}/profile`} target="_blank" rel="noreferrer" className={styles.adminLink}>
      Tara candidate profile
    </a>
  )
}

export default AdminPanel
